module.exports = __webpack_public_path__ + "img/hk_inactive@3x.d61c7c0a.png";